module.exports = __webpack_public_path__ + "static/media/ic-play-book.3d27a876.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic-play-book.svg
// module id = 656
// module chunks = 0